module.exports = __webpack_public_path__ + "static/media/service_system_6.31f8daa1.png";